import { render, staticRenderFns } from "./StatisticsSingleCard.vue?vue&type=template&id=2bbe5964"
import script from "./StatisticsSingleCard.vue?vue&type=script&lang=js"
export * from "./StatisticsSingleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports